import { memo } from 'react'
import { Box, List, ListItemButton } from '@mui/material'
import { Text } from '@/components/Data'
import { bannerDropdownListStyles as styles } from './BannerDropdownList.style'
import { BannerDropdownListProps } from './BannerDropdownList.types'

function BannerDropdownList({ title, data = [] }: BannerDropdownListProps) {
  if (data.length === 0) return null

  return (
    <Box sx={styles.container}>
      <Box sx={styles.headingWrapper}>
        <Text sx={styles.heading} id="nested-list-subheader">
          {title}
        </Text>
      </Box>

      <List sx={styles.list} component="ul" aria-labelledby="nested-list-subheader">
        {data.map((item) => (
          <ListItemButton key={item.id} href={item.url}>
            <Box>
              <Text sx={styles.listItemHeading}>{item.name}</Text>
              {item.description && <Text sx={styles.listItemDesc}>{item.description}</Text>}
            </Box>
          </ListItemButton>
        ))}
      </List>

      <Box sx={styles.divider} className="divider" />
    </Box>
  )
}

export default memo(BannerDropdownList)
